export interface OptionProps {
  label: string;
  value: string;
}

export const isKeyOfObject = <T extends object>(
  key: PropertyKey,
  object: T
): key is keyof T => !!key && !!object && key in object;

export type WithRequired<T, K extends keyof T> = T & { [P in K]-?: T[P] };

export const getEnumValueByStringValue = <T>(
  enumObj: T,
  value: string | null | undefined
): T[keyof T] | undefined => {
  if (typeof value !== "string") {
    return undefined;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const anyEnumObj = enumObj as any;
  const result = Object.entries(anyEnumObj).find(
    ([_, enumValue]) => String(enumValue) === value
  );
  const [key] = result || [];

  return key ? anyEnumObj[key] : undefined;
};

export type ArrayElement<ArrayType extends readonly unknown[]> =
  ArrayType extends readonly (infer ElementType)[] ? ElementType : never;
